// extracted by mini-css-extract-plugin
export var standaloneTable = "_if-0";
export var standaloneTableWithBodyFill = "_if-1";
export var withExtraHeader = "_if-2";